export const FETCH_MENU = 'app/FETCH_MENU';
export const FETCH_MENU_SUCCEED = 'app/FETCH_MENU_SUCCEED';
export const FETCH_MENU_FAILED = 'app/FETCH_MENU_FAILED';
export const TRIGGER_LOGIN_MODAL = 'app/TRIGGER_LOGIN_MODAL';
export const LOGIN = 'app/LOGIN';
export const LOGOUT = 'app/LOGOUT';
export const SET_IS_TRANSITIONING = 'app/SET_IS_TRANSITIONING';
